import angular from 'angular';
import ComponentsModule from '../components-module';

const COMPONENT_NAME = 'codeUi';

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template: '<transclude-replace></transclude-replace>',
    transclude: true
  });

export default COMPONENT_NAME;
